export const SUBMISSION_TYPE_OPTIONS = [
  {
    value: 'E',
    text: 'Electronical',
  },
  {
    value: 'M',
    text: 'Manually',
  },
  {
    value: '-',
    text: 'Unknown',
  },
];
